var React = require('react');

function OpenArrowCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("title",{"key":1},"open-arrow-sircle"),React.createElement("polygon",{"points":"17 21.79 9.61 15.46 10.39 14.54 17 20.21 23.61 14.54 24.39 15.46 17 21.79","key":2}),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":3})]);
}

OpenArrowCircle.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = OpenArrowCircle;

OpenArrowCircle.default = OpenArrowCircle;
